import { Component, Input } from '@angular/core';

@Component({
    selector: 'muni-gameday-radio-item',
    templateUrl: './radio-item.template.html',
    styleUrls: ['./radio-item.styles.scss'],
    standalone: false,
})
export class RadioItemComponent {
    @Input()
    id: number;
    @Input()
    shortcut: string;
    @Input()
    selected: boolean;
}
